var _path, _g, _path2, _g2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1198_76176",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 40,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.612 8L20.0125 8.00399C27.0759 8.14481 33.4804 12.0175 39.226 19.623V19.623L38.9001 20.0495C33.1296 27.5132 26.7003 31.245 19.612 31.245V31.245L19.2116 31.241C12.1501 31.1002 5.74461 27.2275 0 19.623C5.853 11.874 12.392 8 19.612 8V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1198_76176)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.633 34.878H42.858V4.368H-3.633V34.878Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1198_76176",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.762 10.813L20.1214 10.8205C24.6501 11.0087 28.262 14.7379 28.262 19.313V19.313L28.2545 19.6723C28.0663 24.1995 24.3371 27.813 19.762 27.813V27.813L19.4027 27.8055C14.8755 27.6172 11.262 23.8865 11.262 19.313C11.262 14.6175 15.0682 10.813 19.762 10.813V10.813Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1198_76176)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26199 34.813H35.262V5.813H6.26199V34.813Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 12
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.2358,
    y: 1.41421,
    width: 4.70861,
    height: 46.1735,
    transform: "rotate(45 34.2358 1.41421)",
    fill: "#151515",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye_off.82fd2155dcde6ea0dd4e9a4cfe4c3c96.svg";
export { ForwardRef as ReactComponent };